export default {
	resellers: [],
};
